export const siteConfig = {
  name: '开云体育',
  fullName: '开云体育官方下载',
  domain: 'https://www.kaiyunsports.com',
  slogan: '官方正版 · 安全稳定 · 即刻体验',
  description: '开云体育app下载官方渠道，支持iOS与Android双端免费安装，享受体育竞技实时赛事、赛果查询、在线投注等全功能体验。',
  founded: '2015',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '赛事分类', href: '/category/football' },
  { label: '体育资讯', href: '/article/app-download-guide' },
  { label: '关于我们', href: '/about' },
];

export const features = [
  {
    icon: 'ri-smartphone-line',
    title: '双端兼容',
    description: '全面支持iOS与Android系统，适配各类手机型号，提供流畅稳定的使用体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全加密',
    description: '采用国际领先的SSL加密技术，全方位保障用户信息安全与资金安全。',
  },
  {
    icon: 'ri-live-line',
    title: '实时赛事',
    description: '覆盖全球各大体育赛事，提供实时比分直播、赛事数据与专业分析。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速到账',
    description: '多种支付方式支持，充值秒到、提现快捷，让您畅享无忧投注体验。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天客服',
    description: '7x24小时专业客服团队在线，随时为您解答疑问，处理各类问题。',
  },
  {
    icon: 'ri-gift-line',
    title: '丰厚福利',
    description: '新用户注册即享丰厚礼包，日常活动不断，让您玩得更尽兴。',
  },
];

export const downloadSteps = [
  {
    step: 1,
    title: '访问官网',
    description: '通过浏览器访问开云体育官方网站，点击页面下载按钮。',
    icon: 'ri-global-line',
  },
  {
    step: 2,
    title: '选择平台',
    description: '根据您的手机系统选择iOS或Android版本进行下载。',
    icon: 'ri-smartphone-line',
  },
  {
    step: 3,
    title: '安装应用',
    description: '下载完成后，按照提示完成安装（iOS需信任企业证书）。',
    icon: 'ri-download-cloud-2-line',
  },
  {
    step: 4,
    title: '注册登录',
    description: '打开应用完成注册，即可开始享受开云体育全功能体验。',
    icon: 'ri-user-add-line',
  },
];

export const categories = [
  {
    slug: 'football',
    name: '足球赛事',
    icon: 'ri-football-line',
    count: 1280,
    description: '英超、西甲、意甲、德甲、法甲等欧洲五大联赛及世界杯、欧冠等国际赛事全覆盖。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20at%20night%20with%20dramatic%20green%20pitch%20lighting%2C%20empty%20field%20with%20stadium%20lights%2C%20sports%20atmosphere%2C%20dark%20green%20and%20gold%20tones%2C%20cinematic%20sports%20photography%2C%20clean%20professional%20look&width=800&height=500&seq=kaiyun-cat-football&orientation=landscape',
  },
  {
    slug: 'basketball',
    name: '篮球赛事',
    icon: 'ri-basketball-line',
    count: 960,
    description: 'NBA、CBA、欧洲篮球联赛等全球顶级篮球赛事，实时比分与专业分析。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20court%20with%20dramatic%20lighting%2C%20empty%20indoor%20arena%2C%20orange%20and%20dark%20tones%2C%20sports%20atmosphere%2C%20cinematic%20sports%20photography%2C%20clean%20minimal%20background&width=800&height=500&seq=kaiyun-cat-basketball&orientation=landscape',
  },
  {
    slug: 'esports',
    name: '电子竞技',
    icon: 'ri-gamepad-line',
    count: 720,
    description: 'LOL、DOTA2、CS:GO、王者荣耀等热门电竞项目，实时赛事数据与专业解说。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20gaming%20arena%20with%20dramatic%20neon%20lighting%2C%20empty%20stage%20with%20gaming%20setup%2C%20dark%20atmosphere%20with%20accent%20lights%2C%20cinematic%20photography%2C%20clean%20modern%20look&width=800&height=500&seq=kaiyun-cat-esports&orientation=landscape',
  },
  {
    slug: 'tennis',
    name: '网球赛事',
    icon: 'ri-base-station-line',
    count: 540,
    description: '四大满贯、ATP、WTA等世界顶级网球赛事，实时比分直播与专业分析。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20with%20dramatic%20lighting%2C%20clay%20court%20surface%2C%20empty%20stadium%2C%20warm%20earthy%20tones%2C%20cinematic%20sports%20photography%2C%20clean%20minimal%20background&width=800&height=500&seq=kaiyun-cat-tennis&orientation=landscape',
  },
  {
    slug: 'racing',
    name: '赛车竞技',
    icon: 'ri-speed-up-line',
    count: 320,
    description: 'F1方程式、MotoGP、NASCAR等顶级赛车赛事，极速体验与专业数据。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20racing%20circuit%20at%20dusk%2C%20empty%20track%20with%20dramatic%20lighting%2C%20speed%20and%20motion%20atmosphere%2C%20dark%20and%20metallic%20tones%2C%20cinematic%20sports%20photography%2C%20clean%20professional%20look&width=800&height=500&seq=kaiyun-cat-racing&orientation=landscape',
  },
  {
    slug: 'boxing',
    name: '搏击格斗',
    icon: 'ri-boxing-line',
    count: 280,
    description: 'UFC、拳击、自由搏击等格斗赛事，热血对决实时观看与专业分析。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20boxing%20ring%20with%20dramatic%20spotlight%20lighting%2C%20empty%20arena%2C%20red%20and%20dark%20tones%2C%20intense%20atmosphere%2C%20cinematic%20sports%20photography%2C%20clean%20minimal%20background&width=800&height=500&seq=kaiyun-cat-boxing&orientation=landscape',
  },
];

export const articles = [
  {
    slug: 'app-download-guide',
    title: '开云体育app下载安装完整教程（2025最新版）',
    excerpt: '详细介绍开云体育app在iOS和Android设备上的下载安装步骤，包含常见问题解答与注意事项。',
    category: '使用教程',
    date: '2025-08-01',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20sports%20app%20interface%20on%20clean%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20green%20and%20gold%20accent%20colors%2C%20minimal%20composition&width=800&height=500&seq=kaiyun-article-guide&orientation=landscape',
    featured: true,
  },
  {
    slug: 'football-premier-league-preview',
    title: '2025-26赛季英超联赛前瞻：争冠格局深度分析',
    excerpt: '新赛季英超联赛即将拉开帷幕，本文将从球队阵容、战术打法等多维度分析本赛季争冠格局。',
    category: '足球',
    date: '2025-08-03',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Premier%20League%20stadium%20panoramic%20view%20at%20sunset%2C%20green%20pitch%20with%20dramatic%20sky%2C%20professional%20sports%20photography%2C%20atmospheric%20lighting%2C%20clean%20composition&width=800&height=500&seq=kaiyun-article-epl&orientation=landscape',
    featured: true,
  },
  {
    slug: 'nba-playoffs-analysis',
    title: 'NBA季后赛深度解析：东西部决赛对阵预测',
    excerpt: 'NBA季后赛进入白热化阶段，东西部决赛即将打响，本文为您深度解析各队实力与晋级前景。',
    category: '篮球',
    date: '2025-08-02',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20court%20with%20dramatic%20arena%20lighting%2C%20professional%20sports%20photography%2C%20orange%20and%20dark%20tones%2C%20atmospheric%20indoor%20arena%2C%20clean%20composition&width=800&height=500&seq=kaiyun-article-nba&orientation=landscape',
    featured: false,
  },
  {
    slug: 'esports-lol-worlds',
    title: '英雄联盟全球总决赛赛制详解与观赛指南',
    excerpt: 'LOL全球总决赛即将开启，本文详细介绍赛事赛制、参赛队伍及观赛渠道，助您不错过任何精彩对决。',
    category: '电竞',
    date: '2025-07-28',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Esports%20gaming%20arena%20with%20dramatic%20blue%20and%20purple%20stage%20lighting%2C%20empty%20stage%20with%20gaming%20chairs%2C%20professional%20photography%2C%20atmospheric%20lighting&width=800&height=500&seq=kaiyun-article-lol&orientation=landscape',
    featured: false,
  },
  {
    slug: 'betting-strategy-beginner',
    title: '体育投注入门指南：新手必知的五大基本原则',
    excerpt: '刚接触体育投注？本文为您梳理五大核心原则，助您建立科学的投注思维，理性参与体育竞技。',
    category: '投注指南',
    date: '2025-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Professional%20analyst%20desk%20with%20sports%20data%20charts%20on%20monitor%2C%20warm%20office%20lighting%2C%20clean%20modern%20workspace%2C%20green%20accent%20details%2C%20professional%20photography&width=800&height=500&seq=kaiyun-article-betting&orientation=landscape',
    featured: false,
  },
  {
    slug: 'tennis-grand-slam-history',
    title: '网球四大满贯历史之最：经典对决与传奇纪录',
    excerpt: '回顾网球四大满贯赛事历史上最令人难忘的经典对决，致敬那些创造传奇的伟大球员。',
    category: '网球',
    date: '2025-07-20',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Tennis%20grand%20slam%20stadium%20at%20golden%20hour%2C%20clay%20court%20with%20dramatic%20sunset%20lighting%2C%20professional%20sports%20photography%2C%20warm%20atmospheric%20tones%2C%20clean%20composition&width=800&height=500&seq=kaiyun-article-tennis&orientation=landscape',
    featured: false,
  },
];

export const faqs = [
  {
    question: '开云体育app是否免费下载？',
    answer: '是的，开云体育app完全免费下载。无论iOS还是Android用户，均可通过官方网站免费获取正版安装包，无需支付任何下载费用。',
  },
  {
    question: '开云体育app是否安全可靠？',
    answer: '开云体育app采用国际领先的SSL加密技术与多重安全防护机制，全方位保障用户信息与资金安全。平台持有合法运营资质，运营多年信誉卓著。',
  },
  {
    question: 'iOS系统如何安装开云体育app？',
    answer: 'iOS用户访问官网后点击iOS下载按钮，下载完成后需前往"设置-通用-设备管理"中信任企业证书即可正常使用。详细步骤可参考安装教程。',
  },
  {
    question: '安卓系统如何安装开云体育app？',
    answer: '安卓用户访问官网点击安卓下载按钮，下载APK文件后，在手机设置中开启"允许安装未知来源应用"即可完成安装。',
  },
  {
    question: '开云体育app支持哪些支付方式？',
    answer: '开云体育app支持多种支付方式，包括银行卡转账、微信支付、支付宝、USDT等主流支付渠道，充值秒到账，提现快速处理。',
  },
  {
    question: '如何联系开云体育客服？',
    answer: '您可以通过App内在线客服、官方客服热线或发送邮件至官方邮箱联系我们。客服团队7x24小时全天候为您服务。',
  },
];

export const aboutInfo = {
  brandIntro: '开云体育成立于2015年，是亚洲领先的综合性体育服务平台。多年来，我们始终秉持"诚信为本、用户至上"的经营理念，致力于为全球体育爱好者提供安全、便捷、专业的体育竞技服务体验。',
  mission: '以科技创新驱动体育服务升级，让每一位用户都能享受到公平、透明、高效的体育竞技体验。',
  vision: '成为全球最受信赖的体育服务平台，推动体育产业的数字化与智能化发展。',
  values: [
    { title: '诚信经营', description: '坚持公平公正原则，以诚信赢得用户信赖。' },
    { title: '技术创新', description: '持续投入技术研发，不断提升平台性能与安全性。' },
    { title: '用户至上', description: '以用户需求为导向，持续优化服务体验。' },
    { title: '责任担当', description: '积极履行社会责任，倡导理性体育竞技。' },
  ],
  milestones: [
    { year: '2015', event: '开云体育品牌正式创立' },
    { year: '2017', event: '移动端App正式上线，用户突破100万' },
    { year: '2019', event: '获得国际体育博彩运营牌照' },
    { year: '2021', event: '平台用户突破1000万，覆盖全球150+国家' },
    { year: '2023', event: '推出全新版本App，引入AI赛事分析功能' },
    { year: '2025', event: '持续创新，致力于打造全球顶级体育服务平台' },
  ],
  contact: {
    email: 'service@kaiyunsports.com',
    phone: '400-888-6666',
    wechat: 'KaiYunSports',
    hours: '7x24小时全天候服务',
  },
};